import {$getRoot, $getSelection} from 'lexical';
import {useEffect, useState, useCallback, useRef} from 'react';

import {AutoFocusPlugin} from '@lexical/react/LexicalAutoFocusPlugin';
import {LexicalComposer} from '@lexical/react/LexicalComposer';
import {RichTextPlugin} from '@lexical/react/LexicalRichTextPlugin';
import {ContentEditable} from '@lexical/react/LexicalContentEditable';
import {HistoryPlugin} from '@lexical/react/LexicalHistoryPlugin';
import {LexicalErrorBoundary} from '@lexical/react/LexicalErrorBoundary';
import { MuiContentEditable, placeHolderSx } from './styles';
import { Box, Divider } from '@mui/material';
import Toolbar from './Toolbar';
import lexicalEditorTheme from '../../theme/lexicalEditorTheme';
import { lexicalEditorConfig } from './config';

import { OnChangePlugin } from "@lexical/react/LexicalOnChangePlugin";
import { useLexicalComposerContext } from "@lexical/react/LexicalComposerContext";
import { ListPlugin } from "@lexical/react/LexicalListPlugin";
import { LinkPlugin } from "@lexical/react/LexicalLinkPlugin";
import { $generateHtmlFromNodes } from "@lexical/html";
import ImagesPlugin from './plugin/ImagePlugin';
import FloatingTextFormatToolbarPlugin from './plugin/FloatingTextFormatPlugin';

// Catch any errors that occur during Lexical updates and log them
// or throw them as needed. If you don't throw them, Lexical will
// try to recover gracefully without losing user data.
function onError(error) {
  console.error(error);
}

const LoadContentPlugin = ({ initialValue }) => {
    const [editor] = useLexicalComposerContext();
    const isInitialized = useRef(false);

    useEffect(() => {
        if (!isInitialized.current && initialValue) {
        const editorState = editor.parseEditorState(initialValue);
        editor.setEditorState(editorState);
        isInitialized.current = true;
        }
    }, [editor, initialValue]);

  return null;
};

export default function EditorActu({value, handleChange}) {
    const [vl, setVl] = useState(null);
    const [html, setHtml] = useState("");

    const onChange = useCallback(
        (editorState) => {
        handleChange(editorState.toJSON());
        },
        [handleChange]
    );

    return (
        <LexicalComposer initialConfig={lexicalEditorConfig}>
            <Toolbar />
            <Divider />
            <Box sx={{position: "relative", background: "white", color: "black", mt: 1}}>
                <RichTextPlugin // #312D4B
                    contentEditable={<MuiContentEditable />}
                    placeholder={<Box sx={placeHolderSx}>Saisir le contenu...</Box>}
                    ErrorBoundary={LexicalErrorBoundary}
                />
                <OnChangePlugin onChange={onChange} />
                <HistoryPlugin />
                <ImagesPlugin captionsEnabled={false}/>
                <ListPlugin />
                <LinkPlugin />
                <FloatingTextFormatToolbarPlugin />
                {value && <LoadContentPlugin initialValue={value} />}
            </Box>
            {/**
            <div dangerouslySetInnerHTML={{ __html: html }} />
            **/}
        </LexicalComposer>
    );
}